<template>
  <div>
    <v-card>
      <v-card-title>Asignar Cargos Adicionales</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="6">
            <v-combobox
              v-model="cargo"
              :items="cargosLst"
              item-text="cargo"
              item-value="id"
              label="Cargo"
              clearable
              ref="cargo"
              append-icon="mdi-passport"
              return-object
            ></v-combobox>
          </v-col>
          <v-col cols="8" md="4" sm="4">
            <v-text-field
              v-model="observacion"
              label="Observación"
              append-icon="mdi-briefcase-search"
            ></v-text-field>
          </v-col>
          <v-col cols="4" sm="2" md="2">
            <v-text-field
              v-model="valor"
              label="Valor"
              type="number"
              append-icon="mdi-cash"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row dense>
            <v-col class="text-right">
                <v-spacer></v-spacer>
                <v-btn outlined color="primary" @click="addCargo()">Agregar <v-icon>mdi-arrow-right-bold-circle</v-icon></v-btn>
            </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="12" md="12">
            <v-card elevation="10" outlined>
              <v-card-text>
                <v-data-table
                  :headers="headersC"
                  :items="cargosTbl"
                  class="elevation-1"
                >
                  <template v-slot:item.acciones="{ item }">
                    <v-tooltip bottom color="#96298A">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          color="red"
                          @click="deleteCargo(item)"
                          v-bind="attrs"
                          v-on="on"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                      </template>
                      <span>Eliminar</span>
                    </v-tooltip>
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>        
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer
        ><span>Total Cargos Adicionales: ${{totalCargos}}</span>
      </v-card-actions>
    </v-card>
    <v-overlay :value="overlay">
      <waiting />
    </v-overlay>
  </div>
</template>

<script>
import Waiting from "./Waiting.vue";
import apicon from "../plugins/apicon";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components: {
    Waiting,
  },
  created: function () {},
  data() {
    return {            
      headersC: [
        { text: "Cargo", value: "cargo.cargo" },
        { text: "Observación", value: "observacion" },
        { text: "Valor", value: "valor" },
        { text: "Acciones", align: "end", value: "acciones", sortable: false },
      ],
      cargosLst: [],
      cargo: null,
      observacion: null,
      valor: null,
      cargosTbl: [],
      overlay: false,
      totalCargos: 0,
    };
  },
  methods: {
    fillCargosLst: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "cargosadicionales")
        .then((result) => {
          this.cargosLst = result;
        });
    },
    fillCargosGuia: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "cargosadicionalesguiabyguia/" + this.id)
        .then((result) => {
          this.cargosTbl = result;
        });
    },
    addCargo: function () {
      //Validar datos
      if (this.cargo != null) {
          if(this.valor != null){
              var datos = {
                id_guia: this.id,
                id_cargo: this.cargo.id,
                observacion: this.observacion,
                valor: this.valor
                };
                apicon
                .saveDataApi(apicon.getApiBaseUrl() + "cargosadicionalesguia", datos)
                .then(async() => {
                    //this.$swal(result.message);
                    this.cargo = null;
                    this.observacion = null;
                    this.valor = null;
                    this.$refs.cargo.focus();
                    await this.fillCargosGuia();
                    await this.totalizarCargos();
                });
          }else{
              this.$swal("Por favor seleccione el valor del cargo");
          }        
      } else {
        this.$swal("Por favor seleccione el cargo a agregar");
      }
    },
    deleteCargo: function (item) {
      var self = this;
      this.$swal(this.dswalEliminar).then((resultdlg) => {
        if (resultdlg.value) {
          apicon
            .deleteDataApi(
              apicon.getApiBaseUrl() + "cargosadicionalesguia/" + item.id
            )
            .then(async(result) => {
              await self.fillCargosGuia();
              await self.totalizarCargos();
              this.$swal(result.message);
            });
        }
      });
    },        
    totalizarCargos:async function(){
        this.totalCargos = await  this.cargosTbl.reduce(
        (sumT, item) => sumT + parseFloat(item.valor),
        0
      );
    }
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    await this.fillCargosLst();
    await this.fillCargosGuia();        
    await this.totalizarCargos();
  },
};
</script>